export const getReturnsAndExchangesChartSeries = theme => {
  return {
    bars: [
      { label: 'Productos devueltos', field: 'refund_count', color: theme.colors.danger.onSurface },
      { label: 'Productos cambiados', field: 'exchange_count', color: theme.colors.ai.onSurface },
    ],
    line: {
      label: 'Tasa de cambios',
      field: 'exchange_percentage',
      color: theme.colors.ai.onSurface,
      labelColor: theme.colors.ai.default,
    },
  }
}
